module.exports = __webpack_public_path__ + "static/media/3.ea7864d2.svg";